import { StoreIconType, StoreItemCategory } from '../../entity_datas/StoreEnums.ts';
import { BaseStoreItem } from '../BaseStoreItem.ts';
import { LobbyImage } from '@colonist/types';
// Image/item icons
export class SIIconRobberCupid extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.RobberCupid, this.name = {
            key: 'strings:storePage.icons.cupidRobber'
        }, this.price = 250, this.image = LobbyImage.IconRobberCupid, this.activeInStore = true;
    }
}
export class SIIconRobberLunar extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.RobberLunar, this.name = {
            key: 'strings:storePage.icons.lunarRobber'
        }, this.price = 250, this.image = LobbyImage.IconRobberLunar, this.activeInStore = true;
    }
}
export class SIIconRobberSanta extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.RobberSanta, this.name = {
            key: 'strings:storePage.icons.santaRobber'
        }, this.price = 250, this.image = LobbyImage.IconRobberSanta, this.activeInStore = false;
    }
}
export class SIIconPirateShip extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.PirateShip, this.name = {
            key: 'strings:storePage.icons.pirateShip'
        }, this.price = 250, this.image = LobbyImage.IconPirateShip, this.activeInStore = true;
    }
}
export class SIIconChristmasHat extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.ChristmasHat, this.name = {
            key: 'strings:storePage.icons.christmasHat'
        }, this.price = 250, this.image = LobbyImage.IconChristmasHat, this.activeInStore = true;
    }
}
export class SIIconElephant extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Elephant, this.name = {
            key: 'strings:storePage.icons.elephant'
        }, this.price = 250, this.image = LobbyImage.IconElephant, this.activeInStore = false;
    }
}
export class SIIconAvocado extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Avocado, this.name = {
            key: 'strings:storePage.icons.avocado'
        }, this.price = 250, this.image = LobbyImage.IconAvocado, this.activeInStore = true;
    }
}
export class SIIconCactus extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Cactus, this.name = {
            key: 'strings:storePage.icons.cactus'
        }, this.price = 250, this.image = LobbyImage.IconCactus, this.activeInStore = true;
    }
}
export class SIIconGifter extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Gifter, this.name = {
            key: 'strings:storePage.icons.gifter'
        }, this.text = {
            key: 'strings:storePage.sections.avatar.unlockByGifting'
        }, this.image = LobbyImage.IconGifter, this.activeInStore = true, this.bannerText = {
            key: 'strings:storePage.newItem'
        }, this.hideOnDiscordMobile = true;
    }
}
export class SIIconCrown extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Crown, this.name = {
            key: 'strings:storePage.icons.crown'
        }, this.price = 250, this.image = LobbyImage.IconCrown, this.activeInStore = true;
    }
}
export class SIIconSwords extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Swords, this.name = {
            key: 'strings:storePage.icons.swords'
        }, this.price = 250, this.image = LobbyImage.IconSwords, this.activeInStore = true;
    }
}
// Player Icons with something extra
export class SIIconSombrero extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Sombrero, this.name = {
            key: 'strings:storePage.icons.sombrero'
        }, this.price = 100, this.image = LobbyImage.IconSombrero, this.activeInStore = true;
    }
}
export class SIIconFarmer extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Farmer, this.name = {
            key: 'strings:storePage.icons.farmer'
        }, this.price = 100, this.image = LobbyImage.IconFarmer, this.activeInStore = true;
    }
}
export class SIIconHelmet extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Helmet, this.name = {
            key: 'strings:storePage.icons.helmet'
        }, this.price = 100, this.image = LobbyImage.IconHelmet, this.activeInStore = true;
    }
}
export class SIIconSnorkel extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Snorkel, this.name = {
            key: 'strings:storePage.icons.snorkel'
        }, this.price = 100, this.image = LobbyImage.IconSnorkel, this.activeInStore = true;
    }
}
export class SIIconScarf extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Scarf, this.name = {
            key: 'strings:storePage.icons.scarf'
        }, this.price = 100, this.image = LobbyImage.IconScarf, this.activeInStore = true;
    }
}
export class SIIconTie extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Tie, this.name = {
            key: 'strings:storePage.icons.tie'
        }, this.price = 100, this.image = LobbyImage.IconTie, this.activeInStore = true;
    }
}
export class SIIconWorker extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Worker, this.name = {
            key: 'strings:storePage.icons.worker'
        }, this.price = 100, this.image = LobbyImage.IconWorker, this.activeInStore = true;
    }
}
export class SIIconMummy extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Mummy, this.name = {
            key: 'strings:storePage.icons.mummy'
        }, this.price = 400, this.image = LobbyImage.IconMummy, this.activeInStore = false;
    }
}
export class SIIconPlayer extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.Player, this.name = {
            key: 'strings:storePage.icons.colonist'
        }, this.price = 0, this.image = LobbyImage.User, this.activeInStore = true;
    }
}
// Founder icons
export class SIIconFounderHat extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.FounderHat, this.name = {
            key: 'strings:storePage.icons.founderHat'
        }, this.price = 100000, this.image = LobbyImage.IconFounderHat, this.activeInStore = false;
    }
}
export class SIIconColonistHat extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.ColonistHat, this.name = {
            key: 'strings:storePage.icons.colonisthat'
        }, this.price = 50000, this.image = LobbyImage.IconColonistHat, this.activeInStore = false;
    }
}
export class SIIconSettlerHat extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.SettlerHat, this.name = {
            key: 'strings:storePage.icons.settlerHat'
        }, this.price = 25000, this.image = LobbyImage.IconSettlerHat, this.activeInStore = false;
    }
}
// Medal icons
export class SIIconMedalGold extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.MedalGold, this.name = {
            key: 'strings:storePage.icons.goldMedal'
        }, this.price = 9999999, this.image = LobbyImage.IconMedalGold, this.activeInStore = false;
    }
}
export class SIIconMedalSilver extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.MedalSilver, this.name = {
            key: 'strings:storePage.icons.silverMedal'
        }, this.price = 9999999, this.image = LobbyImage.IconMedalSilver, this.activeInStore = false;
    }
}
export class SIIconMedalBronze extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Icon, this.type = StoreIconType.MedalBronze, this.name = {
            key: 'strings:storePage.icons.bronzeMedal'
        }, this.price = 9999999, this.image = LobbyImage.IconMedalBronze, this.activeInStore = false;
    }
}
